import { SVG } from "ui";
import { profileBG } from "utils/assets_exports/images";

import newsImg from "assets/img/news.jpg";

export type CommunityHeaderProps = {
    showInfo: boolean;
    setShowInfo: React.Dispatch<React.SetStateAction<boolean>>;
    handleOpenMembersFromHeader: () => void;
};

const CommunityHeader = ({
    showInfo,
    setShowInfo,
    handleOpenMembersFromHeader
}: CommunityHeaderProps) => {
    return (
        <div className="profile-header">
            <div className="cover-bg">
                <img className="cover-image" src={profileBG} alt="" />
                <div className="avatar">
                    <img
                        id="user-avatar"
                        className="avatar-image"
                        src={newsImg}
                        alt=""
                    />
                    <div className="avatar-button">
                        <i className="mdi mdi-camera"></i>
                    </div>
                </div>
                <div className="cover-overlay"></div>
                <div
                    className="cover-edit modal-trigger"
                    data-modal="change-cover-modal"
                >
                    <i className="mdi mdi-camera"></i>
                    <span>Edit cover image</span>
                </div>
                {/* <!--/html/partials/pages/profile/timeline/dropdowns/timeline-mobile-dropdown.html-->
        {{> timeline-mobile-dropdown}} */}
            </div>

            <div className="profile-subheader flex-j-center pt-20 pb-20 pr-10 pl-10">
                <div className="subheader-middle">
                    <h2>News Community</h2>
                </div>
            </div>

            <div className="profile-about pb-20 pr-10 pl-10">
                <p className="momeento-p text-center w-full">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                </p>
            </div>

            <div className="profile-meta d-flex flex-j-between flex-a-start gap-5  pr-10 pl-10 pb-20">
                {/* invite */}
                <div className="profile-meta-item">
                    <SVG svg="follow" size={24} className="blue-white-svg" />
                    <span className="momeento-p">Invite</span>
                </div>
                {/* indirect followers */}
                <div className="profile-meta-item">
                    <SVG svg="users-add" size={24} className="blue-white-svg" />
                    <span className="momeento-p">Join</span>
                </div>
                {/* follow */}
                <div className="profile-meta-item">
                    {/* followed */}
                    <SVG svg="send" size={24} className="blue-white-svg" />
                    <span className="momeento-p">Share</span>
                </div>
                {/* message */}
                {showInfo ? (
                    <div
                        className="profile-meta-item"
                        onClick={() => setShowInfo(false)}
                    >
                        <SVG
                            svg="topics"
                            size={24}
                            className="blue-white-svg"
                        />
                        <span className="momeento-p cursor-pointer">Posts</span>
                    </div>
                ) : (
                    <div
                        className="profile-meta-item"
                        onClick={() => setShowInfo(true)}
                    >
                        <SVG svg="info2" size={24} className="blue-white-svg" />
                        <span className="momeento-p cursor-pointer">Info</span>
                    </div>
                )}
                {/* <div className="profile-meta-item">
                    <div className="dropdown is-hoverable is-spaced is-right is-neutral dropdown-trigger">
                        <SVG
                            svg="more-vertical"
                            size={24}
                            className="blue-white-svg"
                        />
                        <div className="dropdown-menu" role="menu">
                            <div className="dropdown-content">
                                <a href="#" className="dropdown-item">
                                    <div className="media d-flex flex-j-start flex-a-center gap-10">
                                        <SVG
                                            svg="hide-pswd"
                                            size={18}
                                            className="light-grey-svg"
                                        />
                                        <div className="media-content">
                                            <h3>item</h3>
                                        </div>
                                    </div>
                                </a>
                                <a href="#" className="dropdown-item">
                                    <div className="media d-flex flex-j-start flex-a-center gap-10">
                                        <SVG
                                            svg="hide-pswd"
                                            size={18}
                                            className="light-grey-svg"
                                        />
                                        <div className="media-content">
                                            <h3>another item</h3>
                                        </div>
                                    </div>
                                </a>
                                <a href="#" className="dropdown-item">
                                    <div className="media d-flex flex-j-start flex-a-center gap-10">
                                        <SVG
                                            svg="flag"
                                            size={18}
                                            className="light-grey-svg"
                                        />
                                        <div className="media-content">
                                            <h3>Report Community</h3>
                                        </div>
                                    </div>
                                </a>
                                <a href="#" className="dropdown-item">
                                    <div className="media d-flex flex-j-start flex-a-center gap-10">
                                        <SVG
                                            svg="user-minus"
                                            size={18}
                                            className="light-grey-svg"
                                        />
                                        <div className="media-content">
                                            <h3>Unfollow user</h3>
                                        </div>
                                    </div>
                                </a>

                                <a href="#" className="dropdown-item">
                                    <div className="media d-flex flex-j-start flex-a-center gap-10">
                                        <SVG
                                            svg="slash"
                                            size={18}
                                            className="light-grey-svg"
                                        />
                                        <div className="media-content">
                                            <h3>Block user</h3>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>

            <div className="community-page-members-section d-flex flex-j-start flex-a-center gap-10">
                <div
                    className="members-group d-flex flex-j-start flex-a-center  cursor-pointer"
                    onClick={handleOpenMembersFromHeader}
                >
                    <img
                        src="https://via.placeholder.com/300x300"
                        data-demo-src="assets/img/avatars/dan.jpg"
                        data-user-popover="1"
                        alt=""
                    />
                    <img
                        src="https://via.placeholder.com/300x300"
                        data-demo-src="assets/img/avatars/david.jpg"
                        data-user-popover="4"
                        alt=""
                    />
                    <img
                        src="https://via.placeholder.com/300x300"
                        data-demo-src="assets/img/avatars/edward.jpeg"
                        data-user-popover="5"
                        alt=""
                    />
                    <img
                        src="https://via.placeholder.com/300x300"
                        data-demo-src="assets/img/avatars/milly.jpg"
                        data-user-popover="7"
                        alt=""
                    />
                </div>
                <div className="members-text">
                    <p
                        className="fw-500 cursor-pointer"
                        onClick={handleOpenMembersFromHeader}
                    >
                        6.5k members
                    </p>
                </div>
            </div>
        </div>
    );
};

export default CommunityHeader;
